import { Redirect } from 'react-router-dom';
export default Redirect;
